module.exports = "pegasus_template/assets/frame-large-facebook.png";